export default "__VITE_ASSET__9a1f33ef__"